import React from 'react';
import CommitteeEvaluations from '../committee/CommitteeEvaluations';
import { Box, Heading, Text } from '@chakra-ui/react';

/**
 * AdminEvaluations component
 * Wrapper for CommitteeEvaluations to display in admin panel
 * Shows all evaluations submitted by committee members across all branches
 */
const AdminEvaluations = () => {
  return (
    <Box>
      <Box mb={6}>
        <Heading as="h1" size="xl" mb={2}>تقييمات المرشحين</Heading>
        <Text color="gray.600">عرض جميع تقييمات المرشحين المقدمة من أعضاء اللجان لجميع الفروع</Text>
      </Box>
      
      {/* Use the CommitteeEvaluations component with admin mode */}
      <CommitteeEvaluations isAdminView={true} />
    </Box>
  );
};

export default AdminEvaluations;
